export class FrontendApiConfigurationError extends Error {
  constructor(code, message) {
    super(message)
    this.name = 'FrontendApiConfigurationError'
    this.code = code
  }
}

const configurationError = (code, message) =>
  new FrontendApiConfigurationError(code, message)

const resolveExplicitBaseUrl = (value) => {
  if (typeof value !== 'string' || value.trim() === '') {
    throw configurationError(
      'FRONTEND_API_BASE_URL_INVALID',
      'The frontend API base URL must be a non-empty string.',
    )
  }

  const trimmedValue = value.trim()
  let parsedUrl

  try {
    parsedUrl = new URL(trimmedValue)
  } catch (error) {
    throw configurationError(
      'FRONTEND_API_BASE_URL_INVALID',
      'The frontend API base URL must be an absolute URL.',
    )
  }

  const normalizedPathname = parsedUrl.pathname.endsWith('/')
    ? parsedUrl.pathname.slice(0, -1)
    : parsedUrl.pathname

  if (
    !['http:', 'https:'].includes(parsedUrl.protocol) ||
    parsedUrl.username !== '' ||
    parsedUrl.password !== '' ||
    parsedUrl.search !== '' ||
    parsedUrl.hash !== '' ||
    !normalizedPathname.endsWith('/api/v1')
  ) {
    throw configurationError(
      'FRONTEND_API_BASE_URL_INVALID',
      'The frontend API base URL does not satisfy the required URL contract.',
    )
  }

  return trimmedValue.endsWith('/') ? trimmedValue.slice(0, -1) : trimmedValue
}

export const resolveApiBaseUrlPolicy = (env = process.env) => {
  const nodeEnv = env.NODE_ENV

  if (
    nodeEnv !== undefined &&
    !['development', 'test', 'production'].includes(nodeEnv)
  ) {
    throw configurationError(
      'FRONTEND_API_ENV_INVALID',
      'NODE_ENV must be development, test, or production.',
    )
  }

  if (Object.prototype.hasOwnProperty.call(env, 'REACT_APP_API_BASE_URL')) {
    return Object.freeze({
      baseUrl: resolveExplicitBaseUrl(env.REACT_APP_API_BASE_URL),
      source: 'explicit',
    })
  }

  if (nodeEnv === 'production') {
    throw configurationError(
      'FRONTEND_API_BASE_URL_REQUIRED',
      'An explicit frontend API base URL is required in production.',
    )
  }

  if (nodeEnv === 'development' || nodeEnv === 'test') {
    return Object.freeze({
      baseUrl: '/api/v1',
      source: 'local-fallback',
    })
  }

  throw configurationError(
    'FRONTEND_API_ENV_INVALID',
    'NODE_ENV is required when no frontend API base URL is configured.',
  )
}
